import type { FieldCondition } from '@aviv-estimation-funnel/data-validation/types';
import type { ValidationResult } from '@aviv-estimation-funnel/data-validation/validation-result';
import { preprocessData } from '@mfe-helpers/validationPreprocessor';
import { IFields } from '@mfe-types/form';
import { IReactHookFormErrors } from '@mfe-types/validator';
import { Resolver } from 'react-hook-form';

export const reactHookFormResolver: Resolver<Record<string, any>, IFields> = async (
    fieldValues,
    stepFields,
) => {
    const preprocessedData = preprocessData(fieldValues);
    const reactHookFormErrors: IReactHookFormErrors = {};
    try {
        for (const fieldName in stepFields) {
            const fieldValidator = stepFields[fieldName].validators;
            const shouldSkipValidation = stepFields[fieldName].displayedConditions?.every(
                (condition: FieldCondition) => {
                    const displayedField = condition(fieldValues);

                    return !displayedField;
                },
            );

            if (fieldValidator && !shouldSkipValidation) {
                try {
                    const validationResult: ValidationResult = await fieldValidator.validate(
                        fieldName,
                        preprocessedData,
                    );

                    for (const fieldName in validationResult.errorsPerFieldName) {
                        reactHookFormErrors[fieldName] = {
                            type: validationResult.errorsPerFieldName[fieldName][0].code,
                            types: validationResult.errorsPerFieldName[fieldName],
                        };
                    }
                } catch (e) {
                    throw new Error('An error occured while form data were validating', {
                        cause: e,
                    });
                }
            }
        }

        return {
            values: fieldValues,
            errors: reactHookFormErrors,
        };
    } catch (error) {
        return {
            values: fieldValues,
            errors: reactHookFormErrors,
        };
    }
};
